import styled from "styled-components";
import { Theme } from "theme";

export const Table = styled.table`
  border-spacing: 0;
  width: 100%;

  th {
    white-space: nowrap;
  }
`;

// todo - dupe border code with Swiss Table
const borderLeftCell = styled.td`
  border-left: ${Theme.panelContentBorder};
`;

export const HeaderRow = styled.tr`
  background: ${Theme.tabBackground};

  th {
    border-bottom: ${Theme.panelContentBorder};
    border-left: ${Theme.panelContentBorder};

    &:first-child {
      border-left: 0;
    }

    @media (max-width: 850px) {
      font-size: 10pt;
      padding: 0 3px;
    }
  }
`;

export const TeamRow = styled.tr`
  line-height: 100%;

  td {
    padding-top: 8px;
    padding-bottom: 8px;
    white-space: nowrap;
    border-bottom: ${Theme.panelContentBorder};
  }

  &:last-child {
    td {
      border-bottom: 0;
    }
  }
`;

export const PositionCell = styled.td`
  width: 15px;
  padding-left: ${Theme.bigPanelPaddingHorizontal};

  @media (max-width: 800px) {
    padding-left: ${Theme.smallPanelPadding};
  }
`;

export const OrgLogoCell = styled.td`
  padding-left: 5px;
  width: 24px;
`;

export const OrgLogoContainer = styled.div`
  width: 36px;
  height: 28px;

  @media (max-width: 700px) {
    width: 33px;
    height: 25px;
  }

  @media (max-width: 500px) {
    width: 28px;
    height: 24px;
  }
`;

export const OrgNameCell = styled.td`
  padding-left: 8px;
  min-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  @media (max-width: 850px) {
    padding-left: 3px;
    min-width: 140px;
  }
`;

export const RecordCell = styled(borderLeftCell)`
  text-align: center;
  width: 0;
  padding: 20px;

  @media (max-width: 850px) {
    padding: 10px;
    font-size: 11pt;
  }
`;

export const WinLossRecordCell = styled(RecordCell)`
  font-weight: 500;
  background: ${Theme.tdHighlightBackground};
  color: ${Theme.tdHighlightForeground};
`;

export const HighlightTh = styled.th`
  background: ${Theme.thHighlightBackground};
`;

export const CellSubText = styled.span`
  font-size: 10pt;
  color: gray;
`;

export const DifferentialCell = styled(borderLeftCell)`
  text-align: center;
  width: 0;
  padding: 20px;

  @media (max-width: 850px) {
    padding: 10px;
    font-size: 11pt;
  }
`;
